import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import {
  EditorialMarquee,
  BrandBand,
  Manifesto,
  SpotifyPlaylist,
  Itinerary,
  WhoFor,
  Dehradun,
  VenueGallery,
  Rates,
} from "@/components/site/Content";
import FAQ from "@/components/site/FAQ";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="relative">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <BrandBand />
      <Manifesto />
      <SpotifyPlaylist />
      <Itinerary />
      <WhoFor />
      <Dehradun />
      <VenueGallery />
      <Rates />
      <FAQ />
      <LeadForm />
      <Footer />
    </main>
  );
}
